export const icons = [
    {
        "id": 0,
        "icon": "icon-yinle"
    },
    {
        "id": 1,
        "icon": "icon-rili"
    },
    {
        "id": 2,
        "icon": "icon-chart"
    },
    {
        "id": 3,
        "icon": "icon-chart2"
    },
    {
        "id": 4,
        "icon": "icon-dashboard24"
    },
    {
        "id": 5,
        "icon": "icon-mapsankey"
    },
    {
        "id": 6,
        "icon": "icon-chifan2600"
    },
    {
        "id": 7,
        "icon": "icon-1huojian"
    },
    {
        "id": 8,
        "icon": "icon-yinle1"
    },
    {
        "id": 9,
        "icon": "icon-areachart"
    },
    {
        "id": 10,
        "icon": "icon-leida"
    },
    {
        "id": 11,
        "icon": "icon-chart1"
    },
    {
        "id": 12,
        "icon": "icon-configure"
    },
    {
        "id": 13,
        "icon": "icon-lujingfenxi"
    },
    {
        "id": 14,
        "icon": "icon-huojian"
    },
    {
        "id": 15,
        "icon": "icon-leida1"
    },
    {
        "id": 16,
        "icon": "icon-music_playlist"
    },
    {
        "id": 17,
        "icon": "icon-rili1"
    },
    {
        "id": 18,
        "icon": "icon-Kxiantu"
    },
    {
        "id": 19,
        "icon": "icon-lvyou"
    },
    {
        "id": 20,
        "icon": "icon-guanxitu"
    },
    {
        "id": 21,
        "icon": "icon-erji-lujingguanli"
    },
    {
        "id": 22,
        "icon": "icon-guanxitu1"
    },
    {
        "id": 23,
        "icon": "icon--chart-gear"
    },
    {
        "id": 24,
        "icon": "icon-vynil"
    },
    {
        "id": 25,
        "icon": "icon-diannao"
    },
    {
        "id": 26,
        "icon": "icon-shouji"
    },
    {
        "id": 27,
        "icon": "icon-gongyezujian-yibiaopan"
    },
    {
        "id": 28,
        "icon": "icon-Chart"
    },
    {
        "id": 29,
        "icon": "icon-radarchart"
    },
    {
        "id": 30,
        "icon": "icon-guanxitu2"
    },
    {
        "id": 31,
        "icon": "icon-diannao_o"
    },
    {
        "id": 32,
        "icon": "icon-gongzuoliu_o"
    },
    {
        "id": 33,
        "icon": "icon-gongzuotai"
    },
    {
        "id": 34,
        "icon": "icon-yundong-"
    },
    {
        "id": 35,
        "icon": "icon-yundong-1"
    },
    {
        "id": 36,
        "icon": "icon-yundong-2"
    },
    {
        "id": 37,
        "icon": "icon-chart-pie-alt"
    },
    {
        "id": 38,
        "icon": "icon-chart-relation"
    },
    {
        "id": 39,
        "icon": "icon-chart-scatter-plot"
    },
    {
        "id": 40,
        "icon": "icon-chart-area"
    },
    {
        "id": 41,
        "icon": "icon-chart-line"
    },
    {
        "id": 42,
        "icon": "icon-chart-bar"
    },
    {
        "id": 43,
        "icon": "icon-qiche"
    },
    {
        "id": 44,
        "icon": "icon-lvyoufabu"
    },
    {
        "id": 45,
        "icon": "icon-Infochart"
    },
    {
        "id": 46,
        "icon": "icon-radar-chart"
    },
    {
        "id": 47,
        "icon": "icon-relitu"
    },
    {
        "id": 48,
        "icon": "icon-chart3"
    },
    {
        "id": 49,
        "icon": "icon-charts_area"
    },
    {
        "id": 50,
        "icon": "icon-icon-chart"
    },
    {
        "id": 51,
        "icon": "icon-chart-bar-alt"
    },
    {
        "id": 52,
        "icon": "icon-thermogram"
    },
    {
        "id": 53,
        "icon": "icon-bar_d_chart"
    },
    {
        "id": 54,
        "icon": "icon-line_chart"
    },
    {
        "id": 55,
        "icon": "icon-qiche1"
    },
    {
        "id": 56,
        "icon": "icon-shouji1"
    },
    {
        "id": 57,
        "icon": "icon-Hierarchychart"
    },
    {
        "id": 58,
        "icon": "icon-Chart1"
    },
    {
        "id": 59,
        "icon": "icon-Hierarchychart1"
    },
    {
        "id": 60,
        "icon": "icon-jurassic_heliuxiangdai"
    },
    {
        "id": 61,
        "icon": "icon-shutu"
    },
    {
        "id": 62,
        "icon": "icon-guanxitu3"
    },
    {
        "id": 63,
        "icon": "icon-chart-area-solid"
    },
    {
        "id": 64,
        "icon": "icon-Chart2"
    },
    {
        "id": 65,
        "icon": "icon-ComboChart"
    },
    {
        "id": 66,
        "icon": "icon-w_leida"
    },
    {
        "id": 67,
        "icon": "icon-sanweizuobiao"
    },
    {
        "id": 68,
        "icon": "icon-feidiegua"
    },
    {
        "id": 69,
        "icon": "icon-xuexiao"
    },
    {
        "id": 70,
        "icon": "icon-Chart-10"
    },
    {
        "id": 71,
        "icon": "icon-yibiaopan"
    },
    {
        "id": 72,
        "icon": "icon-loudoutu"
    },
    {
        "id": 73,
        "icon": "icon-xuritu"
    },
    {
        "id": 74,
        "icon": "icon-sangjitu"
    },
    {
        "id": 75,
        "icon": "icon-zuobiaotongji1"
    },
    {
        "id": 76,
        "icon": "icon-piechart_1"
    },
    {
        "id": 77,
        "icon": "icon-zuobiaodingwei"
    },
    {
        "id": 78,
        "icon": "icon-loudoutu1"
    },
    {
        "id": 79,
        "icon": "icon-orbit"
    },
    {
        "id": 80,
        "icon": "icon-orbit-full"
    },
    {
        "id": 81,
        "icon": "icon-chart4"
    },
    {
        "id": 82,
        "icon": "icon-flow-chart"
    },
    {
        "id": 83,
        "icon": "icon-chart5"
    },
    {
        "id": 84,
        "icon": "icon-pie-chart"
    },
    {
        "id": 85,
        "icon": "icon-shuxingtu"
    },
    {
        "id": 86,
        "icon": "icon-barchart"
    },
    {
        "id": 87,
        "icon": "icon-lujing"
    },
    {
        "id": 88,
        "icon": "icon-juxingshutu"
    },
    {
        "id": 89,
        "icon": "icon-xuritu1"
    },
    {
        "id": 90,
        "icon": "icon-shuxingtu1"
    },
    {
        "id": 91,
        "icon": "icon-nongchang_35xiaoxi"
    },
    {
        "id": 92,
        "icon": "icon-xiangdaorelitu"
    },
    {
        "id": 93,
        "icon": "icon-uncharted"
    },
    {
        "id": 94,
        "icon": "icon-radar-chart1"
    },
    {
        "id": 95,
        "icon": "icon-loudoutu_fuzhi"
    },
    {
        "id": 96,
        "icon": "icon-sanzuobiaoshiyongshenqing-361"
    },
    {
        "id": 97,
        "icon": "icon-Chart-Bar"
    },
    {
        "id": 98,
        "icon": "icon-Chart-Radar"
    },
    {
        "id": 99,
        "icon": "icon-erweirelitu"
    },
    {
        "id": 100,
        "icon": "icon-taiji"
    },
    {
        "id": 101,
        "icon": "icon-mokuai"
    }
];